import { render } from "./StaffHeader.vue?vue&type=template&id=25b4d0f1&scoped=true"
import script from "./StaffHeader.vue?vue&type=script&lang=js"
export * from "./StaffHeader.vue?vue&type=script&lang=js"

import "./StaffHeader.vue?vue&type=style&index=0&id=25b4d0f1&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/zamon-vue/zamon-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25b4d0f1"]])

export default __exports__